import { requestJson } from "@/lib/api";
import type { StockBalance, StockMovement } from "@/lib/types";

interface StockBalanceDto {
  productId: string;
  productName: string;
  categoryCode: string;
  unit: string;
  balance: number;
}

interface StockMovementDto {
  id: string;
  movementType: "RECEIVING" | "PRODUCTION_CONSUMED" | "INVENTORY_ADJUSTMENT";
  quantity: number;
  unit: string;
  notes?: string | null;
  createdAt: string;
  referenceId?: string | null;
}

export async function fetchStockBalances(): Promise<StockBalance[]> {
  return requestJson<StockBalanceDto[]>("/api/v1/admin/stock");
}

export async function fetchProductMovements(productId: string): Promise<StockMovement[]> {
  return requestJson<StockMovementDto[]>(`/api/v1/admin/stock/${productId}/movements`);
}

export async function adjustStockInventory(input: {
  productId: string;
  unit: string;
  newQuantity: number;
  notes?: string;
}): Promise<StockMovement> {
  return requestJson<StockMovementDto>("/api/v1/admin/stock/adjust", {
    method: "POST",
    body: input,
  });
}

export interface StockHistoryPurgeResult {
  deletedMovements: number;
  deletedReceivings: number;
  deletedFiles: number;
}

/** Zera todo o histórico de estoque (movimentos + recebimentos). Somente ADMIN. */
export async function purgeStockHistory(): Promise<StockHistoryPurgeResult> {
  return requestJson<StockHistoryPurgeResult>("/api/v1/admin/stock/history", {
    method: "DELETE",
  });
}
